import { Link } from "@tanstack/react-router";
import { ProfileDropdown } from "~/components/profile-dropdown";
import type { NavbarViewer } from "~/routes/__root";

export function Navbar({ initialViewer }: { initialViewer: NavbarViewer }) {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-border/60 bg-background/80 backdrop-blur-sm">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/icon-256.png"
            alt="Overseer"
            className="h-8 w-8 rounded-lg"
          />
          <span className="text-lg font-bold tracking-tight text-foreground">
            Overseer
          </span>
        </Link>
        <nav className="hidden items-center gap-6 text-sm text-muted-foreground md:flex">
          <Link
            to="/dashboard"
            className="hover:text-foreground transition-colors"
          >
            Dashboard
          </Link>
          <Link
            to="/"
            hash="features"
            className="hover:text-foreground transition-colors"
          >
            Features
          </Link>
          <Link
            to="/"
            hash="pricing"
            className="hover:text-foreground transition-colors"
          >
            Pricing
          </Link>
        </nav>
        <div className="flex items-center gap-3">
          <ProfileDropdown initialViewer={initialViewer} />
        </div>
      </div>
    </header>
  );
}
